import React, { useState } from "react";
import { Sparkles, AlertTriangle, Check } from "lucide-react";

// Propuesta "He encontrado nuevos datos para X" con vista previa campo por campo.
// Los campos nuevos vienen marcados; los conflictos, desmarcados (el usuario decide).
export const PetUpdateProposal = ({ petName, entityName, changes, onApply, onSkip, busy, idPrefix = "pet-update" }) => {
  const [sel, setSel] = useState(() =>
    Object.fromEntries(changes.map((c) => [c.field, !c.conflicto]))
  );
  if (!changes || changes.length === 0) return null;
  const name = entityName || petName;

  const toggle = (f) => setSel((s) => ({ ...s, [f]: !s[f] }));
  const anySel = Object.values(sel).some(Boolean);
  const apply = () => {
    const updates = {};
    changes.forEach((c) => {
      if (sel[c.field]) updates[c.field] = c.nuevo;
    });
    onApply(updates);
  };

  return (
    <div className="bg-[#EFF6F1] border border-[#CDE3D6] rounded-2xl p-4 mt-4" data-testid={`${idPrefix}-proposal`}>
      <div className="flex items-center gap-2 text-[#2E5645]">
        <Sparkles size={20} />
        <h3 className="font-heading font-bold text-base text-[#1C2421]">
          He encontrado nuevos datos para {name}
        </h3>
      </div>
      <p className="text-sm text-[#4A5550] mt-1">
        Revisa cada dato antes de guardar. Nada se actualiza hasta que lo confirmes.
      </p>

      <div className="mt-3 space-y-2">
        {changes.map((c) => (
          <label
            key={c.field}
            data-testid={`${idPrefix}-${c.field}`}
            className={`flex items-start gap-3 rounded-xl border px-3.5 py-3 cursor-pointer transition-colors ${
              sel[c.field] ? "bg-white border-[#3A6B56]" : "bg-white border-[#E5DFD5]"
            }`}
          >
            <input
              type="checkbox"
              data-testid={`${idPrefix}-check-${c.field}`}
              checked={!!sel[c.field]}
              onChange={() => toggle(c.field)}
              className="w-5 h-5 accent-[#3A6B56] mt-0.5 shrink-0"
            />
            <div className="min-w-0 flex-1">
              <p className="font-semibold text-base text-[#1C2421]">{c.label}</p>
              {c.conflicto ? (
                <div className="mt-1 space-y-0.5">
                  <p className="text-sm text-[#6E7A74]">
                    Ficha actual: <span className="font-medium text-[#1C2421]">{String(c.actual)}</span>
                  </p>
                  <p className="text-sm text-[#2E5645]">
                    Del documento: <span className="font-semibold">{String(c.nuevo)}</span>
                  </p>
                  <p className="inline-flex items-center gap-1 text-xs font-semibold text-[#B45309] bg-[#FEF3C7] rounded-full px-2 py-0.5 mt-1">
                    <AlertTriangle size={12} /> He encontrado información diferente. Revísala antes de actualizar.
                  </p>
                </div>
              ) : (
                <p className="text-sm text-[#2E5645] mt-0.5">
                  Del documento: <span className="font-semibold">{String(c.nuevo)}</span>
                </p>
              )}
            </div>
          </label>
        ))}
      </div>

      <div className="flex gap-2.5 mt-4">
        <button
          data-testid={`${idPrefix}-skip`}
          onClick={onSkip}
          disabled={busy}
          className="flex-1 min-h-[48px] rounded-xl bg-white text-[#4A5550] font-semibold text-base border border-[#E5DFD5] hover:bg-[#F2EDE4] disabled:opacity-60"
        >
          No actualizar
        </button>
        <button
          data-testid={`${idPrefix}-apply`}
          onClick={apply}
          disabled={busy || !anySel}
          className="flex-[1.4] min-h-[48px] rounded-xl bg-[#3A6B56] text-white font-semibold text-base hover:bg-[#2E5645] disabled:opacity-60 flex items-center justify-center gap-2"
        >
          <Check size={18} /> {busy ? "Guardando…" : "Actualizar ficha"}
        </button>
      </div>
    </div>
  );
};
